export default __webpack_public_path__ + "static/media/102.ef011d89.jpg";